import { importScreen } from '@infrastructure/splitting';
import { routes } from '@helpers/routes';
import { FEATURE_SWITCHES } from '@src/constants';
import type { RouteProps } from 'react-router-dom';

import { ProductSelection as ProductSelectionPage } from '@screens/ProductSelection';

type Routes = typeof routes[keyof typeof routes];
type Route = {
  path: Routes | Routes[];
  component: ReturnType<typeof importScreen>;
  exact?: Pick<RouteProps, 'exact'>['exact'];
  featureFlag?: typeof FEATURE_SWITCHES[keyof typeof FEATURE_SWITCHES];
};
export type Routing = readonly Route[];

const BriefingsDashboard = importScreen(() => import('./BriefingsDashboard'));

const CandidateProfile = importScreen(() => import('./CandidateProfile'));

const Shortlist = importScreen(() => import('./CandidateShortlist'));

const Longlist = importScreen(() => import('./Longlist'));

const BriefingForm = importScreen(() => import('./BriefingFormRoutes'));

export const Onboarding = importScreen(() => import('./OnboardingRoute'));

export const Miss = () => null;

export const SinglePageShortlistPDF = importScreen(
  () => import('./CandidateShortlist/PDF/SinglePageShortlistPDF'),
);

const Login = importScreen(() => import('./Login'));

export const router: Routing = [
  { path: routes.onboarding, component: Onboarding },
  { path: routes.productSelection, component: ProductSelectionPage },
  { path: routes.printAllCandidates, component: SinglePageShortlistPDF },
  {
    path: [
      routes.briefingShortlistForm,
      routes.briefingLonglistForm,
      routes.oldBriefingForm,
      routes.briefingBadFormStep,
    ],
    component: BriefingForm,
    exact: true,
  },
  { path: routes.briefingsDashboard, component: BriefingsDashboard },
  { path: routes.candidateShortlist, component: Shortlist },
  {
    path: routes.longlist,
    component: Longlist,
  },
  { path: routes.candidateShortlistProfile, component: CandidateProfile },
  { path: routes.candidateLonglistProfile, component: CandidateProfile },
  { path: routes.root, component: BriefingsDashboard },
  { path: routes.login, component: Login },
];
